import * as Yup from "yup";

export const WorkflowTaskFormValidations = Yup.object().shape({
  status: Yup.string().required("Task status is required"),
  reason: Yup.string().required("Task reason is required"),
});
